import React from 'react';
import { Box, Grid, Paper, Tooltip, Typography } from '@mui/material';

interface MetricCounterProps {
  label: string;
  value: number | string;
  icon?: React.ReactNode;
  color?: string;
  tooltip?: string;
  disableHoverEffect?: boolean; // ホバー効果を無効にするフラグ
  onClick?: () => void; // クリックハンドラーを追加
}

/**
 * メトリクスの数値を表示するためのコンポーネント
 */
const MetricCounter: React.FC<MetricCounterProps> = ({
  label,
  value,
  icon,
  color = 'primary.main',
  tooltip,
  disableHoverEffect = false,
  onClick
}) => {
  const counterElement = (
    <Paper
      elevation={0}
      onClick={onClick}
      sx={{
        p: 1.5,
        bgcolor: 'rgba(250, 250, 250, 0.7)', // より薄いグレー背景
        borderRadius: 2,
        border: '1px solid rgba(0, 0, 0, 0.20)', // 細い枠線を追加
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minWidth: 130, // 最小幅を設定
        transition: disableHoverEffect ? 'none' : 'all 0.3s ease-in-out', // スムーズな遷移効果
        cursor: onClick ? 'pointer' : 'default', // クリック可能な場合はポインターカーソル
        '&:hover': disableHoverEffect ? {} : {
          transform: 'translateY(-4px)',
          boxShadow: 3
        }
      }}
    >
      <Grid container spacing={1} alignItems="center">
        {icon && (
          <Grid item>
            <Box sx={{ color, mr: 1, display: 'flex' }}>{icon}</Box>
          </Grid>
        )}
        <Grid item xs>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            {label}
          </Typography>
          <Typography
            variant="h5"
            component="div"
            sx={{
              fontWeight: 'medium',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            {typeof value === 'number' ? value.toLocaleString() : value}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
  // 改行文字 \n で文字列を分割して複数の要素に変換
  const createMultilineTooltip = (text: string) => {
    return (
      <div style={{ textAlign: 'left', fontSize: '0.875rem' }}>
        {text.split('\n').map((line, i) => (
          <div key={i}>{line}</div>
        ))}
      </div>
    );
  };

  return tooltip ? (
    <Tooltip 
      title={createMultilineTooltip(tooltip)}
      arrow 
      placement="top"
    >
      {counterElement}
    </Tooltip>
  ) : counterElement;
};
export default MetricCounter;
